import { CountdownTimer } from '@/components/molecule/CountdownTimer';

import { INVITE_COMMON_CONFIG } from '../../../constants';
import { ShareButtons } from './ShareButtons';

export const BottomSection = () => {
  return (
    <div className="sticky bottom-0 w-full">
      <CountdownTimer
        endDate={INVITE_COMMON_CONFIG.event.endDate}
        label="마감까지"
      />
      <div className="w-full bg-Gray-black/25 backdrop-blur-md">
        <ShareButtons endDate={INVITE_COMMON_CONFIG.event.endDate} />
      </div>
    </div>
  );
};
